import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { LabPageRoutingModule } from './lab-routing.module';
import { LabPage } from './lab.page';
import { IonicRatingModule } from 'ionic4-rating';
import { InViewportModule } from 'ng-in-viewport';
import { DocAppointmentPageModule } from '../doc-appointment/doc-appointment.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LabPageRoutingModule,
    IonicRatingModule,
    InViewportModule,
    DocAppointmentPageModule
   // Ng2SearchPipeModule
  ],
  declarations: [LabPage],
  exports : [LabPage]
})
export class LabPageModule { }
